import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { reportTextTemplateKeys } from './reportTextTemplates.key';
import type { ReportTextTemplateKey } from '../../../features/report-templates/reportTextTemplateKeys';

export type { ReportTextTemplateKey };

export function useGetReportTextTemplate(key: ReportTextTemplateKey) {
  const getApi = useApi();

  const getTemplate = async () => {
    const api = await getApi();
    const res = await api.reportTextTemplatesFindOne(key);
    return res.data;
  };

  return useQuery({
    queryKey: reportTextTemplateKeys.findOne(key),
    queryFn: getTemplate,
  });
}
